import { setQueriesDataFromKey } from '@pba/react-query';
import type { ChatroomDataObject } from '#models/services';
import { useQueryClient } from '#react-query';
import type { ChatroomsQueryData } from '../use-get-chatroom';
import { getChatroomDetailQueryKey } from '../use-get-chatroom/keys';
import { type ChatroomsInfiniteQueryData, getChatroomsInfiniteQueryKey } from '../use-get-chatrooms';

export const useUpdateChatroomInCache = () => {
  const queryClient = useQueryClient();

  return ({ newChatroom }: { newChatroom: ChatroomDataObject }) => {
    setQueriesDataFromKey<ChatroomsQueryData>(
      queryClient,
      getChatroomDetailQueryKey({ id: newChatroom._id }),
      newChatroom,
    );

    setQueriesDataFromKey<ChatroomsInfiniteQueryData>(queryClient, getChatroomsInfiniteQueryKey({}), (data) => {
      if (!data) {
        return {
          pageParams: [],
          pages: [[newChatroom]],
        };
      }

      return {
        pageParams: data.pageParams,
        pages: data.pages.map((page) =>
          page.map((chatroom) => (chatroom?._id === newChatroom._id ? newChatroom : chatroom)),
        ),
      };
    });
  };
};
